/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { ReactElement, useState, useCallback, useMemo, useEffect } from 'react';

import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { InputSearch, Button, Table, GoBackButton } from '~/components';
import { TrainingStoreModal } from '~/components/TrainingStoreModal';
import { useLoading } from '~/hooks/loading';
import { TrainingStoreService } from '~/services';

import * as S from './styles';

interface ITrainingStoreListRouteState {
  segmentName: string;
}

interface ITrainingStore {
  description: string;
  id: number;
}

function TrainingStoreList(): ReactElement {
  const { setLoading } = useLoading();

  const { segmentName } = useParams<ITrainingStoreListRouteState>();
  const [trainingStore, setTrainingStore] = useState<ITrainingStore[]>([]);
  const [searchFilter, setSearchFilter] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
  const [removeButtonFocused, setRemoveButtonFocused] = useState(false);
  const router = useHistory();

  const decodedSegmentName = useMemo(() => {
    if (segmentName) {
      return decodeURIComponent(segmentName);
    }
    return '';
  }, [segmentName]);

  if (!decodedSegmentName) {
    toast.error('Segmento muscular inválido.');
    router.goBack();
  }

  const handleGetTrainingStore = useCallback(async () => {
    try {
      setLoading(true);

      const response = await TrainingStoreService.getFilterTrainingStores(
        decodedSegmentName,
        searchFilter,
      );
      const formatResponse: ITrainingStore[] = [];

      response.data.forEach((item) => {
        const { description, id } = item;
        formatResponse.push({ description, id });
      });
      setTrainingStore(formatResponse);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Ocorreu um problema ao carregar os dados!');
    }
  }, [searchFilter, decodedSegmentName]);

  const handleNavigateToEditTrainingStore = useCallback(
    (trainingStoreId: number) => {
      if (!removeButtonFocused) {
        router.push(`/ilab/training-store/edit/${trainingStoreId}`);
      }
    },
    [removeButtonFocused, router],
  );

  useEffect(() => {
    handleGetTrainingStore();
  }, [modalIsOpen, handleGetTrainingStore, searchFilter]);

  const TrainingStoreTableMemo = useMemo(
    () => (
      <Table noItems={trainingStore?.length === 0} colsNames={['Tipo', '', '']}>
        {trainingStore?.map((item) => (
          <tr
            key={item.id}
            onClick={() => handleNavigateToEditTrainingStore(item.id)}
          >
            <td style={{ width: '80%' }}>{item.description}</td>
            <td>{'>'}</td>
          </tr>
        ))}
      </Table>
    ),
    [handleNavigateToEditTrainingStore, trainingStore],
  );

  // console.log('oi');
  console.log('trainingStore:', trainingStore);
  console.log('searchFilter:', searchFilter);

  return (
    <>
      <GoBackButton
        containerStyle={{ alignSelf: 'flex-start', paddingTop: '2.2rem' }}
      />
      <S.Container>
        <S.Header>
          <S.Title>{decodedSegmentName}</S.Title>
          <InputSearch
            name="exercise-search"
            placeholder="Buscar por nome"
            onSearch={(value) => setSearchFilter(value)}
          />
        </S.Header>
        {TrainingStoreTableMemo}
        <S.Footer>
          <Button
            textContent="Criar"
            onClick={() => setModalIsOpen(true)}
            size="small"
            variant="yellow"
            extraStyles={{
              maxWidth: 300,
            }}
          />
        </S.Footer>
      </S.Container>
      <TrainingStoreModal
        modalVisible={modalIsOpen}
        categoryName={decodedSegmentName}
        setModalVisible={setModalIsOpen}
        title="CADASTRAR NOVA CATEGORIA DE DADOS"
        modalType="addCategoryExercise"
      />
    </>
  );
}

export default TrainingStoreList;
